var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDrawing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_535_5267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0262 3.37744L14.7848 0.13607C14.6034 -0.0453567 14.3091 -0.0453567 14.1276 0.13607L6.06795 8.19582C6.00291 8.26087 5.95877 8.34372 5.94088 8.43393L5.13783 12.4783C5.10763 12.6304 5.1551 12.7877 5.2649 12.8975C5.35294 12.9852 5.47149 13.0333 5.59336 13.0333C5.62364 13.0333 5.65384 13.0306 5.68412 13.0246L9.7285 12.2215C9.81863 12.2036 9.90148 12.1592 9.96653 12.0941L18.0262 4.03439C18.2076 3.85319 18.2076 3.55887 18.0262 3.37744ZM6.37195 11.0337L6.79179 8.91967L9.24269 11.3706L7.1287 11.7901L6.37195 11.0337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07477 3.55014C5.86698 8.16638 2.53696 11.0145 2.01597 11.8817C1.35028 12.9902 0.55865 14.5568 1.81977 14.9716C2.58096 15.2217 3.44475 14.0429 3.72864 13.2524C3.93588 12.6756 4.86811 12.9574 4.65951 13.5382C4.21862 14.7658 3.09498 16.2098 1.5953 15.8974C0.480908 15.6654 -0.49366 14.2584 1.0202 11.664C2.12057 9.77831 4.30617 8.54746 3.33913 4.46118C3.02166 3.11872 2.1713 2.01303 0.836911 1.50553C0.254485 1.28426 0.540045 0.373927 1.12776 0.597444C2.55027 1.13818 3.53741 2.16644 4.07477 3.55014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_535_5267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawing);
export default __webpack_public_path__ + "static/media/icon-drawing.cfa3ceacd306a9f5e3cdd3cadba93182.svg";
export { ForwardRef as ReactComponent };